module.exports = __webpack_public_path__ + "r-v3/img/ongoing.860b2fa2.svg";